import './App.css';
import '@aws-amplify/ui-react/styles.css';

import React, { lazy, Suspense, useEffect, useState } from 'react';
import Belowbar from './components/baselayout/Belowbar';
import Navbar from './components/baselayout/Navbar';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { signupEmailOptions, syncPendingSignupConsent } from './components/auth/signupEmail';
import { Route, Routes } from "react-router-dom";
import ProtectedRoutes from './components/baselayout/ProtectedRoutes';
import ScrollToTop from './ScrollToTop';
import { API, graphqlOperation } from 'aws-amplify';
import { getUserProfile } from './graphql/queries';
import OnboardingWizard from './components/baselayout/OnboardingWizard';
import MobileBottomNav from './components/baselayout/MobileBottomNav';
import MarketingOptInPrompt from './components/baselayout/MarketingOptInPrompt';

const Welcome = lazy(() => import('./components/baselayout/Welcome'));
const Courses = lazy(() => import('./components/baselayout/Courses'));
const Dashboard = lazy(() => import('./components/baselayout/Dashboard'));
const Pricing = lazy(() => import('./components/baselayout/Pricing'));
const Comeplete = lazy(() => import('./components/baselayout/Comeplete'));
const Error404 = lazy(() => import('./components/baselayout/Error404'));
const CancelPage = lazy(() => import('./components/baselayout/CancelPage'));
const FreeCourses = lazy(() => import('./components/baselayout/FreeCourses'));
const Challenges = lazy(() => import('./components/baselayout/Challenges'));
const ManageNotice = lazy(() => import('./components/baselayout/ManageNotice.js'));
const FeedbackPage = lazy(() => import('./components/baselayout/FeedbackPage.js'));
const FeedbackDashboard = lazy(() => import('./components/baselayout/FeedbackDashboard.js'));
const NoticeAdminDashboard = lazy(() => import('./components/baselayout/NoticeAdminDashboard.js'));
const ShopComingSoon = lazy(() => import('./components/baselayout/ShopComingSoon.js'));
const AdminAnalyticsDashboard = lazy(() => import('./components/baselayout/AdminAnalyticsDashboard.js'));
const ContentAdmin = lazy(() => import('./components/admin/ContentAdmin.js'));
const AdminHub = lazy(() => import('./components/admin/AdminHub.js'));
const JourneyLessonAdmin = lazy(() => import('./components/admin/JourneyLessonAdmin.js'));
const ChallengeAdmin = lazy(() => import('./components/admin/ChallengeAdmin.js'));
const StudentModerationAdmin = lazy(() => import('./components/admin/StudentModerationAdmin.js'));
const InstructorDirectory = lazy(() => import('./components/content/InstructorDirectory.js'));
const InstructorDetail = lazy(() => import('./components/content/InstructorDetail.js'));
const ClassDirectory = lazy(() => import('./components/content/ClassDirectory.js'));
const DynamicCoursePage = lazy(() => import('./components/content/DynamicCoursePage.js'));
const DynamicLessonPage = lazy(() => import('./components/content/DynamicLessonPage.js'));
const JourneyLessonPage = lazy(() => import('./components/content/JourneyLessonPage.js'));
const StudentsCommunity = lazy(() => import('./components/students/StudentsCommunity.js'));
const StudentProfilePage = lazy(() => import('./components/students/StudentProfilePage.js'));
const Shows = lazy(() => import('./components/shows/Shows.js'));
const ShowEpisodePlayer = lazy(() => import('./components/shows/ShowEpisodePlayer.js'));
const ShowAdmin = lazy(() => import('./components/admin/ShowAdmin.js'));
const PricingAdmin = lazy(() => import('./components/admin/PricingAdmin.js'));
const EmailMarketingAdmin = lazy(() => import('./components/admin/EmailMarketingAdmin.js'));
const BoomItupFree = lazy(() => import('./components/free-lessons/boomitupfreelesson/BoomItupFree'));
const KrazykrazyChalleng = lazy(() => import('./components/challenges/krazy krazy/KrazykrazyChalleng'));

const DynamixTeam = lazy(() => import('./components/cources/dynamix/DynamixTeam'));
const FlameTeam = lazy(() => import('./components/cources/flameteam/FlameTeam'));
const KripticKlique = lazy(() => import('./components/cources/kripticklique/KripticKlique'));
const MiddleSchoolDancehall = lazy(() => import('./components/cources/middleschooldancehall/MiddleSchoolDancehall'));
const OverloadSkankaz = lazy(() => import('./components/cources/overloadskankaz/OverloadSkankaz'));
const ProblemSquad = lazy(() => import('./components/cources/problemsquad/ProblemSquad'));
const TwinStarzz = lazy(() => import('./components/cources/twinstarzz/TwinStarzz'));
const UnstoppableGeneration = lazy(() => import('./components/cources/unstoppablegeneration/UnstoppableGeneration'));
const CrazyShellingz = lazy(() => import('./components/cources/crazyshellingz/CrazyShellingz.js'));
const ShaniceCaterpilla = lazy(() => import('./components/cources/shanicecaterpilla/ShaniceCaterpilla.js'));
const DhqStyle = lazy(() => import('./components/cources/dhqstyle/DhqStyle.js'));
const Others = lazy(() => import('./components/cources/others/Others.js'));
const SopremeBlazzaz = lazy(() => import('./components/cources/sopremeblazzaz/SopremeBlazzaz.js'));

const KwamzAndFlavaOhemaa = lazy(() => import('./components/lessons/dynamixlessons/KwamzAndFlavaOhemaa'));
const VybzKartelScortchEarth = lazy(() => import('./components/lessons/dynamixlessons/VybzKartelScortchEarth'));
const MovadoStarBoy = lazy(() => import('./components/lessons/dynamixlessons/MovadoStarBoy'));
const ChronixxCoolAsTheBreeze = lazy(() => import('./components/lessons/dynamixlessons/ChronixxCoolAsTheBreeze'));
const TheAllianceGangster = lazy(() => import('./components/lessons/dynamixlessons/TheAllianceGangster'));
const TidalWave = lazy(() => import('./components/lessons/dynamixlessons/TidalWave'));
const PullTrigga = lazy(() => import('./components/lessons/dynamixlessons/PullTrigga'));
const Circulate = lazy(() => import('./components/lessons/dynamixlessons/Circulate'));
const InterviewDynamix = lazy(() => import('./components/lessons/dynamixlessons/InterviewDynamix'));
const BillAVibzDynamix = lazy(() => import('./components/lessons/dynamixlessons/BillAVibzDynamix'));
const RyticalCookieJar = lazy(() => import('./components/lessons/overloadlessons/RyticalCookieJar'));
const SeanPaulLikeGlue = lazy(() => import('./components/lessons/overloadlessons/SeanPaulLikeGlue'));
const SeanPaulScorcha = lazy(() => import('./components/lessons/overloadlessons/SeanPaulScorcha'));
const WayneVacancy = lazy(() => import('./components/lessons/overloadlessons/WayneVacancy'));
const InnaMiFeelings = lazy(() => import('./components/lessons/overloadlessons/InnaMiFeelings'));
const SoulFlow = lazy(() => import('./components/lessons/overloadlessons/SoulFlow'));
const TommyLeeTouchTheRoad = lazy(() => import('./components/lessons/overloadlessons/TommyLeeTouchTheRoad.js'));
const MarksmanRunEGrung = lazy(() => import('./components/lessons/overloadlessons/MarksmanRunEGrung.js'));
const ValiantMadOut = lazy(() => import('./components/lessons/overloadlessons/ValiantMadOut.js'));
const Notyet = lazy(() => import('./components/lessons/overloadlessons/Notyet.js'));
const MovadoFtGovanaEarthAHell = lazy(() => import('./components/lessons/overloadlessons/MovadoFtGovanaEarthAHell.js'));
const Swift = lazy(() => import('./components/lessons/problemsquad/Swift'));
const FallaFalla = lazy(() => import('./components/lessons/problemsquad/FallaFalla'));
const MixUp = lazy(() => import('./components/lessons/problemsquad/MixUp'));
const ProblemSquadInterview = lazy(() => import('./components/lessons/problemsquad/ProblemSquadInterview'));
const MasickaIWish = lazy(() => import('./components/lessons/flameteam/MasickaIWish'));
const Comepass = lazy(() => import('./components/lessons/flameteam/Comepass'));
const Hi5 = lazy(() => import('./components/lessons/flameteam/Hi5'));
const BackOff = lazy(() => import('./components/lessons/middleschooldancehalllessons/BackOff'));
const WheelChair = lazy(() => import('./components/lessons/middleschooldancehalllessons/WheelChair'));
const OneDance = lazy(() => import('./components/lessons/middleschooldancehalllessons/OneDance'));
const GimmeSpace = lazy(() => import('./components/lessons/middleschooldancehalllessons/GimmeSpace'));
const PunkRock = lazy(() => import('./components/lessons/middleschooldancehalllessons/PunkRock'));
const Ben = lazy(() => import('./components/lessons/twinstarzzlessons/Ben'));
const Wiper = lazy(() => import('./components/lessons/twinstarzzlessons/Wiper'));
const BoomItUp = lazy(() => import('./components/lessons/twinstarzzlessons/BoomItUp'));
const WildThoughts = lazy(() => import('./components/lessons/twinstarzzlessons/WildThoughts'));
const SlapIt = lazy(() => import('./components/lessons/twinstarzzlessons/SlapIt'));
const AidoniaTipPonYuhToe = lazy(() => import('./components/lessons/twinstarzzlessons/AidoniaTipPonYuhToe'));
const RdxJaw = lazy(() => import('./components/lessons/twinstarzzlessons/RdxJaw'));
const SpiceGum = lazy(() => import('./components/lessons/twinstarzzlessons/SpiceGum'));
const InterviewTwinStarzz = lazy(() => import('./components/lessons/twinstarzzlessons/InterviewTwinStarzz'));
const ElephantOhNahNah = lazy(() => import('./components/lessons/unstoppablegeneration/ElephantOhNahNah'));
const StyloGPutEhDung = lazy(() => import('./components/lessons/unstoppablegeneration/StyloGPutEhDung'));
const ChineyKRiddim = lazy(() => import('./components/lessons/unstoppablegeneration/ChineyKRiddim'));
const Excellent = lazy(() => import('./components/lessons/unstoppablegeneration/Excellent'));
const HandPiece = lazy(() => import('./components/lessons/unstoppablegeneration/HandPiece'));
const BillAVybzUnstoppable = lazy(() => import('./components/lessons/unstoppablegeneration/BillAVybzUnstoppable'));
const UnstoppableGenerationInterview = lazy(() => import('./components/lessons/unstoppablegeneration/UnstoppableGenerationInterview'));
const JimmyCliffTheHarderTheyCome = lazy(() => import('./components/lessons/kripticlessons/JimmyCliffTheHarderTheyCome'));
const CurrentFlow = lazy(() => import('./components/lessons/kripticlessons/CurrentFlow'));
const KriptickliqueInterview = lazy(() => import('./components/lessons/kripticlessons/KriptickliqueInterview'));
const ZoomSkaOldSchool = lazy(() => import('./components/lessons/kripticlessons/ZoomSkaOldSchool'));
const ZoomBougleStepAndHistory = lazy(() => import('./components/lessons/kripticlessons/ZoomBougleStepAndHistory'));
const ZoomMidSchool = lazy(() => import('./components/lessons/kripticlessons/ZoomMidSchool'));
const ZoomNewSchool = lazy(() => import('./components/lessons/kripticlessons/ZoomNewSchool'));
const AidoniaBottles = lazy(() => import('./components/lessons/crazyshellingzlessons/AidoniaBottles.js'));
const Dragdung = lazy(() => import('./components/lessons/crazyshellingzlessons/Dragdung.js'));
const TommyLeeWahWar = lazy(() => import('./components/lessons/crazyshellingzlessons/TommyLeeWahWar.js'));
const AidoniaBukkum = lazy(() => import('./components/lessons/crazyshellingzlessons/AidoniaBukkum.js'));
const CrazyGun = lazy(() => import('./components/lessons/crazyshellingzlessons/CrazyGun.js'));
const Windy = lazy(() => import('./components/lessons/crazyshellingzlessons/Windy.js'));
const JadaToptier = lazy(() => import('./components/lessons/shanicecaterpilla/JadaToptier.js'));
const JordyKillSwitch = lazy(() => import('./components/lessons/dhqstyle/JordyKillSwitch.js'));
const SounBwoiiJiggle = lazy(() => import('./components/lessons/sopremeblazzaz/SounBwoiiJiggle.js'));

function App({ user, signOut }) {
  const [profile, setProfile] = useState(null);
  const [checkingProfile, setCheckingProfile] = useState(true);

  useEffect(() => {
    syncPendingSignupConsent(user).catch((error) => {
      console.warn('Signup email preference will retry on the next visit:', error);
    });
  }, [user]);

  useEffect(() => {
    const checkProfile = async () => {
      try {
        const sub = user?.attributes?.sub;
        if (!sub) {
          setCheckingProfile(false);
          return;
        }

        const res = await API.graphql(
          graphqlOperation(getUserProfile, { id: sub })
        );
        const existingProfile = res?.data?.getUserProfile || null;
        setProfile(existingProfile);
      } catch (err) {
        console.error('Error checking user profile:', err);
      } finally {
        setCheckingProfile(false);
      }
    };

    checkProfile();
  }, [user]);

  if (checkingProfile) {
    return (
      <div className="App">
        <p style={{ padding: 24 }}>Loading ...</p>
      </div>
    );
  }

  if (!profile || profile.onboardingCompleted === false) {
    return (
      <div className="App">
        <OnboardingWizard
          user={user}
          existingProfile={profile}
          onComplete={(createdProfile) => setProfile(createdProfile)}
        />
      </div>
    );
  }

  return (
    <div className="App">
      <Navbar />
      <MarketingOptInPrompt user={user} />
      <ScrollToTop />
      <Suspense fallback={<div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', fontWeight: 800 }}>Loading dance experience…</div>}>
      <Routes>

        {/* pages*/}
        <Route path="/*" element={<Error404 />} />
        <Route path="/payment/cancel" element={<CancelPage />} />
        <Route path="/payment/completed" element={<Comeplete />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/free/courses" element={<FreeCourses />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/classes" element={<ClassDirectory />} />
        <Route path="/challenges" element={<Challenges />} />
        <Route path="/students" element={<StudentsCommunity />} />
        <Route path="/students/video/:videoID" element={<StudentsCommunity />} />
        <Route path="/students/:studentID" element={<StudentProfilePage />} />
        <Route path="/shows" element={<Shows />} />
        <Route path="/shows/episodes/:episodeID" element={<ShowEpisodePlayer />} />
        <Route path="/managenotice" element={<ManageNotice />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/admin/feedback" element={<FeedbackDashboard />} />
        <Route path="/admin/notice" element={<NoticeAdminDashboard />} />
        <Route path="/shop" element={<ShopComingSoon />} />
        <Route path="/admin/analytics" element={<AdminAnalyticsDashboard/>} />
        <Route path="/admin/content" element={<ContentAdmin/>} />
        <Route path="/admin/journey-lessons" element={<JourneyLessonAdmin/>} />
        <Route path="/admin/challenges" element={<ChallengeAdmin/>} />
        <Route path="/admin/students" element={<StudentModerationAdmin/>} />
        <Route path="/admin/shows" element={<ShowAdmin/>} />
        <Route path="/admin/pricing" element={<PricingAdmin/>} />
        <Route path="/admin/email-marketing" element={<EmailMarketingAdmin/>} />
        <Route path="/admin" element={<AdminHub/>} />
        <Route path="/instructors" element={<InstructorDirectory/>} />
        <Route path="/instructors/:instructorSlug" element={<InstructorDetail/>} />
        <Route path="/courses/:courseSlug" element={<DynamicCoursePage/>} />
        <Route path="/lessons/:lessonSlug" element={<DynamicLessonPage/>} />
        <Route path="/journey-lessons/:journeyLessonSlug" element={<JourneyLessonPage/>} />


        {/* free lessons*/}
        <Route path="/free/boomitup" element={<BoomItupFree />} />

        {/* challenges*/}
        <Route path="/challenges/krazykrazy" element={<KrazykrazyChalleng />} />

        {/* protected*/}
        <Route element={<ProtectedRoutes />}>

          <Route path="/" element={<Welcome />} />
          <Route path="/Welcome" element={<Welcome />} />
          {/* courses */}
          <Route path="/dynamixteam" element={<DynamixTeam />} />
          <Route path="/flameteam" element={<FlameTeam />} />
          <Route path="/kripticklique" element={<KripticKlique />} />
          <Route path="/middleschooldancehall" element={<MiddleSchoolDancehall />} />
          <Route path="/overloadskankaz" element={<OverloadSkankaz />} />
          <Route path="/problemsquad" element={<ProblemSquad />} />
          <Route path="/twinstarzz" element={<TwinStarzz />} />
          <Route path="/unstoppablegeneration" element={<UnstoppableGeneration />} />
          <Route path="/crazyshellingz" element={<CrazyShellingz />} />
          <Route path="/shanicecaterpilla" element={<ShaniceCaterpilla />} />
          <Route path="/dhqstyles" element={<DhqStyle />} />
          <Route path="/others" element={<Others />} />
          <Route path="/sopremeblazzaz" element={<SopremeBlazzaz />} />

          {/* dynamix team lessons routes */}
          <Route path="/dynamix-team-ohemaa" element={<KwamzAndFlavaOhemaa />} />
          <Route path="/dynamix-team-scortchearth" element={<VybzKartelScortchEarth />} />
          <Route path="/dynamix-team-starboy" element={<MovadoStarBoy />} />
          <Route path="/dynamix-team-coolasthebreeze" element={<ChronixxCoolAsTheBreeze />} />
          <Route path="/dynamix-team-gangster" element={<TheAllianceGangster />} />
          <Route path="/dynamix-team-tidalwave" element={<TidalWave />} />
          <Route path="/dynamix-team-pulltrigga" element={<PullTrigga />} />
          <Route path="/dynamix-team-circulate" element={<Circulate />} />
          <Route path="/dynamix-team-interviews" element={<InterviewDynamix />} />
          <Route path="/dynamix-team-billavibz" element={<BillAVibzDynamix />} />

          {/* OVERLOAD SKANKAZ lessons routes */}
          <Route path="/overload-skankaz-cookiejar" element={<RyticalCookieJar />} />
          <Route path="/overload-skankaz-likeglue" element={<SeanPaulLikeGlue />} />
          <Route path="/overload-skankaz-scorcha" element={<SeanPaulScorcha />} />
          <Route path="/overload-skankaz-vacancy" element={<WayneVacancy />} />
          <Route path="/overload-skankaz-innamifeelings" element={<InnaMiFeelings />} />
          <Route path="/overload-skankaz-soulflow" element={<SoulFlow />} />
          <Route path="/overload-skankaz-touchtheroad" element={<TommyLeeTouchTheRoad />} />
          <Route path="/overload-skankaz-RunEGrung" element={<MarksmanRunEGrung />} />
          <Route path="/overload-skankaz-madout" element={<ValiantMadOut />} />
          <Route path="/overload-skankaz-notyet" element={<Notyet />} />
          <Route path="/overload-skankaz-earthahell" element={<MovadoFtGovanaEarthAHell />} />

          {/* PROBLEM SQUAD lessons routes */}
          <Route path="/problem-squad-swift" element={<Swift />} />
          <Route path="/problem-squad-fallafalla" element={<FallaFalla />} />
          <Route path="/problem-squad-mixup" element={<MixUp />} />
          <Route path="/problem-squad-interviews" element={<ProblemSquadInterview />} />

          {/* FLAME TEAM lessons routes */}
          <Route path="/flame-team-iwish" element={<MasickaIWish />} />
          <Route path="/flame-team-comppass" element={<Comepass />} />
          <Route path="/flame-team-hi5" element={<Hi5 />} />

          {/* MIDDLE SCHOOL lessons routes */}
          <Route path="/middle-school-backoff" element={<BackOff />} />
          <Route path="/middle-school-wheelchair" element={<WheelChair />} />
          <Route path="/middle-school-onedance" element={<OneDance />} />
          <Route path="/middle-school-gimmespace" element={<GimmeSpace />} />
          <Route path="/middle-school-punkrock" element={<PunkRock />} />

          {/* TWINSTARZZ lessons routes */}
          <Route path="/twinstarzz-ben" element={<Ben />} />
          <Route path="/twinstarzz-wiper" element={<Wiper />} />
          <Route path="/twinstarzz-boomitup" element={<BoomItUp />} />
          <Route path="/twinstarzz-wildthoughts" element={<WildThoughts />} />
          <Route path="/twinstarzz-slapit" element={<SlapIt />} />
          <Route path="/twinstarzz-tipponyuhtoe" element={<AidoniaTipPonYuhToe />} />
          <Route path="/twinstarzz-jaw" element={<RdxJaw />} />
          <Route path="/twinstarzz-gum" element={<SpiceGum />} />
          <Route path="/twinstarzz-interviews" element={<InterviewTwinStarzz />} />

          {/* UNSTOPABLE GENERATION lessons routes */}
          <Route path="/unstoppable-generation-ohnahnah" element={<ElephantOhNahNah />} />
          <Route path="/unstoppable-generation-putehdung" element={<StyloGPutEhDung />} />
          <Route path="/unstoppable-generation-chineykriddim" element={<ChineyKRiddim />} />
          <Route path="/unstoppable-generation-excellent" element={<Excellent />} />
          <Route path="/unstoppable-generation-handpiece" element={<HandPiece />} />
          <Route path="/unstoppable-generation-simonsay" element={<BillAVybzUnstoppable />} />
          <Route path="/unstoppable-generation-interviews" element={<UnstoppableGenerationInterview />} />

          {/* KRIPTIC KLIQUE lessons routes */}
          <Route path="/kriptic-klique-thehardertheycome" element={<JimmyCliffTheHarderTheyCome />} />
          <Route path="/kriptic-klique-currentflow" element={<CurrentFlow />} />
          <Route path="/kriptic-klique-interviews" element={<KriptickliqueInterview />} />
          <Route path="/kriptic-klique-zoom-classes-ska" element={<ZoomSkaOldSchool />} />
          <Route path="/kriptic-klique-zoom-classes-bougle" element={<ZoomBougleStepAndHistory />} />
          <Route path="/kriptic-klique-zoom-classes-midschool" element={<ZoomMidSchool />} />
          <Route path="/kriptic-klique-zoom-classes-newschool" element={<ZoomNewSchool />} />

          {/* crazyshellingz lessons routes */}
          <Route path="/crazyshellingz-bottles" element={<AidoniaBottles />} />
          <Route path="/crazyshellingz-dragdung" element={<Dragdung />} />
          <Route path="/crazyshellingz-wahwar" element={<TommyLeeWahWar />} />
           <Route path="/crazyshellingz-bukkum" element={<AidoniaBukkum />} />
           <Route path="/crazyshellingz-windy" element={<Windy />} />
           <Route path="/crazyshellingz-crazygun" element={<CrazyGun />} />
            

          {/* shanice caterpilla lessons routes */}
          <Route path="/shanice-caterpilla-toptier" element={<JadaToptier />} />

          {/* dhqstyle lessons routes */}
          <Route path="/dhq-killswitch" element={<JordyKillSwitch />} />

          
          {/* sopremeblazzaz lessons routes */}
          <Route path="/sopremeblazzaz-sounbwoiijiggle" element={<SounBwoiiJiggle/>} />

        </Route>
      </Routes>
      </Suspense>

      <MobileBottomNav />
      <Belowbar />
    </div>
  );
}

export default withAuthenticator(App, signupEmailOptions);
